import { render } from "./EditableStarRating.vue?vue&type=template&id=52a3a7da&scoped=true"
import script from "./EditableStarRating.vue?vue&type=script&lang=js"
export * from "./EditableStarRating.vue?vue&type=script&lang=js"

import "./EditableStarRating.vue?vue&type=style&index=0&id=52a3a7da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a3a7da"]])

export default __exports__